import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import About from "@/pages/About";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import { PromptPilot } from "@/components/PromptPilot";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

const LenisRoot = ({ children }) => {
    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return undefined;
        const lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 0.95 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return children;
};

function App() {
    return (
        <div className="App min-h-screen" style={{ background: "#0A0F1E" }}>
            <HelmetProvider>
                <BrowserRouter>
                    <LenisRoot>
                        <ScrollManager />
                        <Header />
                        <main id="main-content">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/services/:slug" element={<ServicePage />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/industries" element={<Industries />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </main>
                        <Footer />
                        <PromptPilot />
                        <Toaster theme="dark" position="bottom-right" richColors />
                    </LenisRoot>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
